import React from 'react';
import styles from './styles.module.less';
import { Icon } from '@/src/tools/icon';
import { Field } from '../../RcForm';
import classNames from 'classnames';
import i18n from '@/src/strategies/i18n';

function Visible(props) {
  const { breakpoint, alwaysVisible, translateDisabled } = props;
  return (
    <Field name={'visible'}>
      {(props, meta) => {
        const { value, onChange } = props;
        const renderI18n = (breakpoint) => {
          return i18n[`general.content.${breakpoint}`];
        };
        return (
          <div className={styles.container}>
            <div
              className={classNames(styles.content, {
                [styles.on]: translateDisabled
                  ? false
                  : alwaysVisible
                  ? true
                  : value,
              })}>
              <span>{renderI18n(breakpoint)}</span>
              {!alwaysVisible && (
                <Icon
                  type={!!value ? 'iconvisible2' : 'iconinvisible1'}
                  className={`${styles.icon} ${
                    translateDisabled ? styles.iconDisable : ''
                  }`}
                  onClick={() => {
                    if (translateDisabled) return;
                    onChange(!value);
                  }}
                />
              )}
            </div>
          </div>
        );
      }}
    </Field>
  );
}

export default Visible;
